export default __webpack_public_path__ + "assets/six.e373f54d.webp";